"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nodes_1 = __importDefault(require("./nodes"));
/**
 * GRAMMAR
 * -------
 *
 * selector = prefix suffix*
 * prefix   = ( name | array | "")
 * suffix   = array | propery
 * propery  = "." name
 * name  = "*" (ID "*")? | ID "*"?
 * array = "[" index "]"
 * index = DIGIT (":" (DIGIT))
 *       | ":" DIGIT
 */
/**
 *
 */
const TOKENS = {
    DIGIT: /-?[0-9]/,
    SYMBOL: /[\[\]\*\.\:]/,
    ID: /[^\[\]\.\*\:]+/,
};
// create non-capturing group
const REGEX = new RegExp('(?:' + Object.values(TOKENS).map(r => r.source).join('|') + ')', "g");
/**
 * Tokenize input string and return array of tokens
 *
 * @param {string} input
 * @return {Object[]}
 * @example
 *
 * tokenize('user.name') // return [{ type: 'ID', value: 'user'} ... ]
 */
function tokenize(input) {
    let r, tokens = [], syms = ['.', '[', ']', '*', ':'];
    while (r = REGEX.exec(input)) {
        let token = r[0], type = 'ID';
        if (syms.indexOf(token) > -1) {
            type = token; // 'SYMBOL'
        }
        else if (!isNaN(token)) {
            type = 'DIGIT';
            token *= 1; // cast to number
        }
        tokens.push({ value: token, type });
    }
    tokens.push({ type: 'EOL' });
    return tokens;
}
exports.tokenize = tokenize;
function accept(type, tokens, advance = true) {
    let token = tokens[0];
    return type === (token && token.type) ? (advance ? tokens.shift() : tokens[0]) : false;
}
function expect(type, tokens) {
    let token = tokens[0];
    if (!accept(type, tokens)) {
        throw new Error(`Expected token ${type} but got ${token.type + (token.value && token.value != token.type ? '(' + token.value + ')' : '')}`);
    }
    return token;
}
/**
 * Parse tokens and returns AST
 *
 * @param {Object[]} tokens
 * @param {Object} object
 */
function parse(tokens) {
    let ast = parseSelector(tokens);
    expect('EOL', tokens);
    return ast;
}
exports.parse = parse;
function parseSelector(tokens) {
    let prefix = accept('[', tokens, false) ? parseArray(tokens) : parseName(tokens);
    // parse suffixes
    let n, suffixes = [];
    while (n = parseSuffix(tokens)) {
        suffixes.push(n);
    }
    return nodes_1.default[nodes_1.default.selector](prefix, suffixes);
}
function parseName(tokens) {
    let token, all = false, end = false;
    let start = accept('*', tokens) ? true : false;
    token = accept('ID', tokens);
    if (token) {
        end = accept('*', tokens) ? true : false;
    }
    // match all wildcard `*`
    all = start && !token;
    let wildcard = all || start || end ? { all, start, end } : false;
    // if it's not star `*`, must have `ID`
    if (!all && !token)
        expect('ID', tokens);
    return nodes_1.default[nodes_1.default.name](token, wildcard);
}
function parseArray(tokens) {
    let start = false, end = false, slice = false, single = false;
    expect('[', tokens);
    // DIGIT (: (DIGIT))
    if (start = accept('DIGIT', tokens)) {
        if (slice = accept(':', tokens)) {
            end = accept('DIGIT', tokens);
        }
    }
    // : DIGIT
    else if (slice = accept(':', tokens)) {
        end = expect('DIGIT', tokens);
    }
    expect(']', tokens);
    single = start && !slice;
    return nodes_1.default[nodes_1.default.array](start, slice, end, single);
}
function parseSuffix(tokens) {
    // [] array
    if (accept('[', tokens, false)) {
        return parseArray(tokens);
    }
    // "." property
    else if (accept('.', tokens)) {
        let name = parseName(tokens);
        return nodes_1.default[nodes_1.default.property](name);
    }
}
//# sourceMappingURL=data:application/json;base64,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